/**
 * AUTO-GENERATED RESULT FEATURE FLAGS
 *
 * This module has functions to generate names of Goodall flags
 * and the `disabled` variants for those flags for results on the vertical.
 *
 * This allows us to add result types and immediately be able to control whether
 * they are rendered or not with feature flags, without custom flag code.
 *
 * We check for `disabled` variants specifically, so we can still allow all result types
 * which aren't explicitly disabled in Goodall.
 */
export const getDisabledVariant = (type) => `st_ab_web_result_${type.toLowerCase()}_disabled`;
export const getExperimentName = (type) => `sea-web-result-${type.toLowerCase()}`;
